export default function (context) {
	// If the player is not authenticated
	if (!context.$cookie.get('token')) {
		context.store.dispatch('settings/toggleIsLogin', false)
		return context.redirect(('/login'))
	}
}
